export const fishHeadMargin = 25;

/** Angle between a vertical line and an Ishikawa branch (8°) */
export const branchAngle = 0.2;
export const branchAngleTan = Math.tan(branchAngle);

/** Minimum width of ishikawa branches in pixels */
export const branchMinWidth = 250;

/** Height of the branch head */
export const branchHeadHeight = 34;

/** Height of an ishikawa cause item in pixels */
export const causeHeight = 30;

/** Cause inner padding in pixels */
export const causePadding = 4;

/** Margin separating cause items in pixels */
export const causeMargin = 8;

/** Margin separating cause items from the diagonal line in pixels */
export const causeRightMargin = 40;

/** x-axis shift for each cause item */
export const causeShift = branchAngleTan * (causeHeight + causeMargin);

/** Gap to the left of cause items in pixels */
export const causeLeftMargin = 30;

export function getIshikawaCauseWidth(state) {
  if (state.device.isSmartphoneLandscape) {
    return 150;
  }
  if (state.device.isTabletLandscape) {
    return 180;
  }
  return 250;
};

export default {
  fishHeadMargin,
  branchAngle,
  branchAngleTan,
  causeHeight,
  causeMargin,
  causeShift,
  getIshikawaCauseWidth,
};
